import * as Yup from 'yup';
import logInModel from '../models/logInModel';

const {
  formField: {
    logInEmail,
    logInPass
  }
} = logInModel;

const logInSchema = {
    loggedIn: Yup.boolean(),
    [logInEmail.name]: Yup.string()
      .email(`${logInEmail.invalidErrorMsg}`)
      .when('loggedIn', ([loggedIn]) => {
        return loggedIn === false 
          ? Yup.string().required(`${logInEmail.requiredErrorMsg}`)
          : Yup.string();
      }),
    [logInPass.name]: Yup.string()
      .when('loggedIn', ([loggedIn]) => {
        return loggedIn === false
          ? Yup.string()
              .required(`${logInPass.requiredErrorMsg}`)
              .min(8, `${logInPass.invalidErrorMsg}`)
          : Yup.string();
      })
};

export default logInSchema
